export default __webpack_public_path__ + "static/hero-f545fa02093f48e63ed1dd9611473f3e.jpg";